import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION8: PdfComponent = {
  type: 'section',
  id: 'iars8',
  title: '8. Remuneration and Set-Off',
  content: [
    {
      type: 'bulletList',
      id: 'iars8bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'The Principal may pay the Introducer an introducer fee in connection with Completed Loans resulting from introductions made by the Introducer in accordance with this Agreement. The amount, basis, and timing of any such fee shall be agreed in writing between the parties from time to time.',
        },
        {
          copy: 'The Introducer acknowledges that any introducer fees are:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'conditional upon full compliance with this Agreement;',
              },
              {
                copy: 'subject to the Customer completing the finance transaction (i.e. Completed Loan status); and',
              },
              {
                copy: 'exclusive of VAT unless otherwise agreed.',
              },
            ],
          },
        },
        {
          copy: 'The Principal may offset or withhold any introducer fees:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'in the event of cancellation, refund, or unwinding of a Credit Agreement;',
              },
              {
                copy: 'where a Customer fails to receive the goods or services in accordance with applicable terms;',
              },
              {
                copy: 'if the Principal reasonably believes that the Introducer has breached this Agreement, FCA rules, or other Applicable Law.',
              },
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: 'iar83',
            content: [
              'Where an introducer fee has already been paid and the related transaction is subsequently cancelled, refunded, unwound, or deemed unenforceable, the Introducer shall ',
              'repay such fee',
              ' to the Principal on demand. The Principal may set off such amount against future payments due.',
            ],
            boldFirst: false,
          },
        },
        {
          copy: 'The Introducer agrees to maintain accurate records of all Customer introductions and to cooperate with any audit or enquiry related to the basis for remuneration.',
        },
      ],
      prefix: '8',
    },
  ],
};
